import { render, staticRenderFns } from "./TaskMailTemplateDlg.vue?vue&type=template&id=67788324&scoped=true"
import script from "./TaskMailTemplateDlg.vue?vue&type=script&lang=js"
export * from "./TaskMailTemplateDlg.vue?vue&type=script&lang=js"
import style0 from "./TaskMailTemplateDlg.vue?vue&type=style&index=0&id=67788324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67788324",
  null
  
)

export default component.exports